import React, { useState, useEffect } from "react";
import Hero from "../../../components/pages/overview/Hero";
import FeaturedCategories from "../../../components/pages/overview/FeaturedCategories";
import LatestListings from "../../../components/pages/overview/LatestListings";
import ServiceHighlights from "../../../components/pages/overview/ServiceHighlights";
import FeaturedProjects from "../../../components/pages/overview/FeaturedProjects";
import Statistics from "../../../components/pages/overview/Statistics";
import BlogSection from "../../../components/pages/overview/BlogSection";
import CallToAction from "../../../components/pages/overview/CallToAction";
import { getAllProjects } from "../../../services/projectService";
import { toast } from "react-toastify";
import SEO from "../../../components/pages/SEO/SEO";
import new1 from "../../../assets/newpage/newpage1.webp";
import new3 from "../../../assets/newpage/newpage3.jpg";
import new5 from "../../../assets/newpage/newpage5.jpg";
import { useNews } from "../../../hooks/pages/news/useNews";

// --- DUMMY DATA ---


const statsData = [
    { label: "Dự án hoàn thành", value: "120+" },
    { label: "Khách hàng hài lòng", value: "3,500+" },
    { label: "Năm kinh nghiệm", value: "8" },
    { label: "Giao dịch thành công", value: "2,800+" },
];


export default function Home() {

    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const { news, loading: newsLoading } = useNews(1, 3);

    const blogs = news.map((item) => ({
        id: item.id,
        title: item.title,
        excerpt: item.summary || item.description || "",
        image: item.thumbnail,
        link: `/news/${item.slug || item.id}`,
    }));
    // 📦 Fetch dữ liệu từ API khi trang load
    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const data = await getAllProjects({}, 1, 4); // gọi API
                setProjects(Array.isArray(data.projects) ? data.projects : []);
            } catch (error) {
                console.error("Lỗi khi tải dự án:", error);
                toast.error("Không thể tải danh sách dự án");
            } finally {
                setLoading(false);
            }
        };
        fetchProjects();
    }, []);

    // ✅ Cấu hình SEO cho trang Home
    const seoData = {
        title: "Mỹ Diệp Property - Trang chủ | Dự án bất động sản cao cấp",
        description: "Khám phá các dự án bất động sản Vinhomes cao cấp trên toàn quốc. Cập nhật dự án mới, tiện ích hiện đại và cơ hội đầu tư sinh lời.",
        keywords: "Vinhomes, dự án bất động sản, căn hộ, biệt thự, shophouse, đầu tư, mua bán, cho thuê",
        image: "/images/og-default.jpg",
        type: "website",
        url: typeof window !== "undefined" ? window.location.href : undefined,
        schema: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Mỹ Diệp Property - Trang chủ",
            "description": "Khám phá các dự án bất động sản Vinhomes cao cấp trên toàn quốc với tiện ích đẳng cấp và cơ hội đầu tư sinh lời.",
            "url": typeof window !== "undefined" ? window.location.href : "https://vinhomesdemo.com",
            "publisher": {
                "@type": "Organization",
                "name": "Mỹ Diệp Property",
                "logo": {
                    "@type": "ImageObject",
                    "url": "/images/logo.png"
                }
            }
        }
    };

    return (
        <>
            {/* 🚀 SEO */}
            <SEO {...seoData} />
            <Hero />
            <FeaturedCategories />
            <LatestListings />
            <ServiceHighlights />
            {/* ✅ Hiển thị loading state hoặc dữ liệu */}
            {loading ? (
                <div className="text-center py-10 text-gray-500">Đang tải dự án...</div>
            ) : (
                <FeaturedProjects projects={projects} />
            )}

            <Statistics stats={statsData} />
            {newsLoading ? (
                <div className="text-center py-10">
                    Đang tải tin tức...
                </div>
            ) : (
                <BlogSection blogs={blogs} />
            )}
            <CallToAction />
        </>
    );
}
